// extracted by mini-css-extract-plugin
export default {"textInput":"ReactionConfig-textInput-a50fa6cbc99d292d3a0f9fc4a6ab66c2","reactionButton":"ReactionConfig-reactionButton-8bab77b9ccee8a1670210b7a8e9926a7"};